var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntlModalCloseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 4.4375L13.8125 11L20.375 17.625C21.1875 18.375 21.1875 19.6875 20.375 20.4375C19.625 21.25 18.3125 21.25 17.5625 20.4375L11 13.875L4.375 20.4375C3.625 21.25 2.3125 21.25 1.5625 20.4375C0.75 19.6875 0.75 18.375 1.5625 17.625L8.125 11L1.5625 4.4375C0.75 3.6875 0.75 2.375 1.5625 1.625C2.3125 0.8125 3.625 0.8125 4.375 1.625L11 8.1875L17.5625 1.625C18.3125 0.8125 19.625 0.8125 20.375 1.625C21.1875 2.375 21.1875 3.6875 20.375 4.4375Z",
    fill: "#008577"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntlModalCloseLogo);
export default __webpack_public_path__ + "static/media/intlModalCloseLogo.db6f417b9343dc266b7c6ab90fda4dba.svg";
export { ForwardRef as ReactComponent };